import { AuthContext, StaffRole } from '@urbanx/agx.auth.client';
import { Pages } from 'constants/menu';
import ContractIcon from 'components/sidebar/icons/contracts-icon';
import { ContentLayout, PageLayout } from 'layout';
import { useContext } from 'react';
import ContractsDashboardHeader from './ContractsDashboardHeader';
import ContractsDashboardTable from './ContractsDashboardTable';
import useContractsDashboard from './useContractsDashboard';

const ContractsDashboard = () => {
  const { userAccount } = useContext(AuthContext);
  const userRoles = (userAccount?.roles as StaffRole[]) || [];
  const {
    rows,
    agencyLookup,
    isPending,
    isAgenciesPending,
    addressSearchText,
    agencyFilterOptions,
    selectedStateOptions,
    onSortSettlement,
    selectedContractStatusOptions,
    selectedSettlementDateOptions,
    selectedVendorBankDetailsOptions,
    setAddressSearchText,
    handleStateFilterSelect,
    handleAgencyFilterSelect,
    handleContractStatusFilterSelect,
    handleSettlementDateFilterSelect,
    handleVendorBankDetailsFilterSelect,
    resetAgencyFilters,
    resetStateFilters,
    resetContractStatusFilters,
    resetSettlementDateFilters,
    resetVendorBankDetailsFilters,
  } = useContractsDashboard();

  const getContractLink = (index: number) => {
    const contract = rows[index];
    if (!contract?.campaignId || !contract.agencyId || !contract.contractId) return;

    const page = userRoles.includes(StaffRole.WorkflowContributor)
      ? Pages.CONTRACT_TASKS
      : Pages.PROPERTY_INFORMATION;

    return `/${Pages.AGENCIES}/${contract.agencyId}/${Pages.CAMPAIGNS}/${contract.campaignId}/${Pages.CONTRACTS}/${contract.contractId}/${page}`;
  };

  const userName = [userAccount?.firstName, userAccount?.lastName]
    .filter((namePart) => namePart != null && namePart.length > 0)
    .join(' ');

  return (
    <PageLayout
      agentName={userName}
      primaryPageTitle="Contracts"
      pageIcon={
        <div className="iconContainer">
          <ContractIcon height="28" width="28" />
        </div>
      }
      header={
        <ContractsDashboardHeader
          addressSearchText={addressSearchText}
          agencyFilterOptions={agencyFilterOptions}
          selectedStateOptions={selectedStateOptions}
          selectedContractStatusOptions={selectedContractStatusOptions}
          selectedSettlementDateOptions={selectedSettlementDateOptions}
          selectedVendorBankDetailsOptions={selectedVendorBankDetailsOptions}
          onAddressSearchTextChange={setAddressSearchText}
          handleStateFilterSelect={handleStateFilterSelect}
          handleAgencyFilterSelect={handleAgencyFilterSelect}
          handleSettlementDateFilterSelect={handleSettlementDateFilterSelect}
          handleVendorBankDetailsFilterSelect={handleVendorBankDetailsFilterSelect}
          handleContractStatusFilterSelect={handleContractStatusFilterSelect}
          resetAgencyFilters={resetAgencyFilters}
          resetStateFilters={resetStateFilters}
          resetContractStatusFilters={resetContractStatusFilters}
          resetSettlementDateFilters={resetSettlementDateFilters}
          resetVendorBankDetailsFilters={resetVendorBankDetailsFilters}
        />
      }
    >
      <ContentLayout hasSecondaryMenu={false}>
        <ContractsDashboardTable
          rows={rows}
          agencyLookup={agencyLookup}
          isPending={isPending}
          isAgenciesPending={isAgenciesPending}
          getContractLink={getContractLink}
          onSortSettlement={onSortSettlement}
        />
      </ContentLayout>
    </PageLayout>
  );
};

export default ContractsDashboard;
